import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import * as React from 'react';
var initialState = {
  time: Date.now(),
  xy: [0, 0],
  delta: [0, 0],
  initial: [0, 0],
  previous: [0, 0],
  direction: [0, 0],
  velocity: 0,
  distance: 0
};
export function useMouseMetrics(_ref) {
  var onMouseMoveProp = _ref.onMouseMove,
      onMouseLeaveProp = _ref.onMouseLeave;
  var state = React.useRef(null);
  var onMouseMove = React.useCallback(function (e) {
    var pageX = e.pageX,
        pageY = e.pageY;

    if (state.current === null) {
      state.current = _objectSpread(_objectSpread({}, initialState), {}, {
        xy: [pageX, pageY],
        initial: [pageX, pageY],
        previous: [pageX, pageY],
        time: Date.now()
      });
      return;
    }

    var s = state.current;
    var time = Date.now();
    var xDist = pageX - s.xy[0];
    var yDist = pageY - s.xy[1];
    var deltaX = pageX - s.initial[0];
    var deltaY = pageY - s.initial[1];
    var distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
    var len = Math.sqrt(xDist * xDist + yDist * yDist);
    var scaler = 1 / (len || 1);
    var velocity = len / (time - s.time);

    if (velocity === 0) {
      return;
    }

    state.current = _objectSpread(_objectSpread({}, state.current), {}, {
      time: time,
      xy: [pageX, pageY],
      delta: [deltaX, deltaY],
      velocity: time - s.time === 0 ? s.velocity : velocity,
      distance: distance,
      direction: [xDist * scaler, yDist * scaler],
      previous: s.xy
    });

    if (onMouseMoveProp) {
      onMouseMoveProp(state.current, e);
    }
  }, [onMouseMoveProp]);
  var onMouseLeave = React.useCallback(function (e) {
    state.current = null;

    if (onMouseLeaveProp) {
      onMouseLeaveProp(e);
    }
  }, [onMouseLeaveProp]);
  return {
    bind: {
      onMouseMove: onMouseMove,
      onMouseLeave: onMouseLeave
    }
  };
}